import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "card-form__main" }
const _hoisted_3 = { class: "card-form__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_phone_input = _resolveComponent("phone-input")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "card-form" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "text-h5" }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            class: "card-form__logo",
            src: require('@/assets/svg/logo.svg'),
            alt: ""
          }, null, 8, _hoisted_1)
        ]),
        _: 1
      }),
      _cache[15] || (_cache[15] = _createElementVNode("hr", { class: "card-form__hr-solid" }, null, -1)),
      _createVNode(_component_v_card_text, { style: {"width":"25rem"} }, {
        default: _withCtx(() => [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "card-form__name" }, " Register ", -1)),
          _createVNode(_component_v_alert, {
            "model-value": !!_ctx.errorText,
            closable: "",
            type: "error",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.errorText = ''))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.errorText), 1)
            ]),
            _: 1
          }, 8, ["model-value"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_form, {
              ref: "form",
              onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.formData.first_name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.first_name) = $event)),
                  label: "Your first name",
                  color: "primary",
                  placeholder: "Enter your first name",
                  rules: [_ctx.rules.required],
                  variant: "outlined",
                  style: {"margin-bottom":"10px"}
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.formData.last_name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.last_name) = $event)),
                  label: "Your last name",
                  color: "primary",
                  placeholder: "Enter your last name",
                  rules: [_ctx.rules.required],
                  variant: "outlined",
                  style: {"margin-bottom":"10px"}
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.formData.email,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.email) = $event)),
                          label: "Your email",
                          color: "primary",
                          placeholder: "Enter your email",
                          rules: [_ctx.rules.required, _ctx.rules.isEmail],
                          variant: "outlined"
                        }, null, 8, ["modelValue", "rules"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { style: {"margin-top":"0px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_phone_input, {
                          ref: "phoneInput",
                          showIcon: false,
                          rules: [_ctx.rules.required]
                        }, null, 8, ["rules"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "6",
                      class: "pb-0 pt-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.formData.password,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.password) = $event)),
                          label: "Password",
                          color: "primary",
                          placeholder: "Enter your password",
                          rules: [_ctx.rules.required, _ctx.rules.minLength, _ctx.rules.bothRegisters],
                          type: "password",
                          variant: "outlined",
                          style: {"margin-bottom":"10px"}
                        }, null, 8, ["modelValue", "rules"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "6",
                      class: "pb-0 pt-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.confirmPassword,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                          label: "Re-enter Password",
                          color: "primary",
                          placeholder: "Re-enter your password",
                          rules: [_ctx.rules.required, _ctx.rules.checkPassword],
                          type: "password",
                          variant: "outlined"
                        }, null, 8, ["modelValue", "rules"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_radio_group, {
                  modelValue: _ctx.formData.gender,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.gender) = $event)),
                  inline: "",
                  rules: [_ctx.rules.required],
                  class: "mt-0 mb-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_radio, {
                      label: "Male",
                      value: "M"
                    }),
                    _createVNode(_component_v_radio, {
                      label: "Female",
                      value: "F"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_checkbox, {
                  color: "primary",
                  modelValue: _ctx.formData.informational_opt_in,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.informational_opt_in) = $event)),
                  label: "I agree to receive essential SMS messages related to my lease, billing and housing updates."
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_checkbox, {
                  color: "primary",
                  modelValue: _ctx.formData.marketing_opt_in,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.marketing_opt_in) = $event)),
                  label: "I'd like to receive promotional, future leasing offers and marketing messages."
                }, null, 8, ["modelValue"]),
                _cache[12] || (_cache[12] = _createElementVNode("p", { class: "card-form__tnc-text" }, [
                  _createTextVNode(" By continuing, I agree to the "),
                  _createElementVNode("a", { href: "https://app.termly.io/policy-viewer/policy.html?policyUUID=874f765d-45a2-464f-9bd0-73f440476bcb" }, "Terms and Conditions"),
                  _createTextVNode(" and "),
                  _createElementVNode("a", { href: "https://app.termly.io/policy-viewer/policy.html?policyUUID=0bfddd13-3802-4d71-980c-6e7aff261e4a" }, "Privacy Policy"),
                  _createTextVNode(". I also agree to receive transactional and promotional emails and text messages. I may reply STOP or update my profile settings to cancel. Standard messaging and data rates apply. ")
                ], -1)),
                _createVNode(_component_v_btn, {
                  class: "card-form__send-button",
                  color: "primary",
                  size: "large",
                  onClick: _ctx.sendForm
                }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createTextVNode(" Sign Up ")
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }, 512)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _cache[13] || (_cache[13] = _createTextVNode(" Already have an account? ")),
            _createElementVNode("a", {
              href: "/",
              onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.$emit('change', 'login')), ["prevent"]))
            }, " Sign in here ")
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}